module.exports = __webpack_public_path__ + "img/projectbanner2.f1e2d749.jpg";